"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadYouTubeVideoByUrl = void 0;
const addYouTubeApiToPage_1 = require("./addYouTubeApiToPage");
const youTubeVideoUrlToId_1 = require("./youTubeVideoUrlToId");
const loadYouTubeVideoByUrl = async (target, videoUrl, options) => {
    if (!videoUrl)
        throw new Error("No YouTube video URL provided");
    const videoId = (0, youTubeVideoUrlToId_1.youTubeVideoUrlToId)(videoUrl);
    await (0, addYouTubeApiToPage_1.addYouTubeApiToPage)();
    return new Promise((res) => {
        const player = new YT.Player(target, Object.assign(Object.assign({ videoId }, options), { events: Object.assign(Object.assign({}, options === null || options === void 0 ? void 0 : options.events), { onReady: (...args) => {
                    var _a, _b;
                    res(player);
                    (_b = (_a = options === null || options === void 0 ? void 0 : options.events) === null || _a === void 0 ? void 0 : _a.onReady) === null || _b === void 0 ? void 0 : _b.call(_a, ...args);
                } }) }));
    });
};
exports.loadYouTubeVideoByUrl = loadYouTubeVideoByUrl;
